import React from 'react';
import Text from '../Text';
import StepBadge, { StepBadgeStatus } from './StepBadge';
import { UpgradeState } from './types';
import dots from './icons/assets/dots.svg';
import activeDots from './icons/assets/dots-active.svg';
import completedDots from './icons/assets/dots-completed.svg';
import AssetGlyph from './icons/AssetGlyph';

export default function MigrationMap({ state }: { state: Exclude<UpgradeState, { status: 'intro' }> }) {
  const complete = state.status === 'success';
  const failed = state.status === 'failure';
  const backingUp = state.status === 'ready';
  const steps: { label: string; detail: string; status: StepBadgeStatus }[] = [
    {
      label: 'Your account',
      detail: backingUp ? 'Backing up' : 'Backed up',
      status: backingUp ? 'active' : 'completed',
    },
    {
      label: 'Migration',
      detail: complete ? 'Complete' : failed ? 'Incomplete' : backingUp ? '' : 'In progress',
      status: complete ? 'completed' : failed ? 'failed' : backingUp ? 'pending' : 'active',
    },
    { label: 'New model', detail: complete ? 'Active' : '', status: complete ? 'completed' : 'pending' },
  ];
  return (
    <div
      className="flex h-56 items-center justify-center gap-2 border-b border-base bg-sub px-6 sm:gap-4 sm:px-10"
      aria-label="Account upgrade stages"
    >
      {steps.map((step, index) => (
        <React.Fragment key={step.label}>
          {index > 0 && (
            <AssetGlyph
              src={complete || failed ? completedDots : !backingUp && index === 1 ? activeDots : dots}
              className={`h-2 w-8 sm:w-16 ${
                complete
                  ? 'text-alert-success'
                  : failed && index === 1
                    ? 'text-alert-warning'
                    : !backingUp && !failed && index === 1
                      ? 'text-link'
                      : 'text-default'
              }`}
            />
          )}
          <div className="flex min-w-0 flex-1 flex-col items-center gap-3 text-center">
            <StepBadge status={step.status} number={index + 1} />
            <Text as="p" variant="base" className="text-sm font-semibold">
              {step.label}
            </Text>
            <Text as="p" variant="muted" className="min-h-5 text-sm">
              {step.detail || '\u00a0'}
            </Text>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
